import Swiper, { Navigation, Pagination, Thumbs } from 'swiper'
import { breakpointUp } from '../utils/breakpoints'

function initPostGallery() {

  const sliderElements = $('.post-gallery .post-gallery-slider')

  if(!sliderElements.length) return false

  sliderElements.each(function () {

    const container = $(this).closest('.post-gallery')
    const thumbsElement = container.find('.post-gallery-slider-thumbs')
    const galleryElement = container.find('.post-gallery-slider')
    const galleryPrevSlide = container.find('.post-gallery-prev-slide')
    const galleryNextSlide = container.find('.post-gallery-next-slide')

    let prevSlideElement = galleryPrevSlide[0]
    let nextSlideElement = galleryNextSlide[0]

    if(breakpointUp('xl')) {
      prevSlideElement = galleryPrevSlide[1]
      nextSlideElement = galleryNextSlide[1]
    }

    const thumbs = new Swiper(thumbsElement[0],{
      slidesPerView: 4,
      spaceBetween: 16,
      freeMode: true,
    })

    const gallery = new Swiper(galleryElement[0],{
      modules: [Navigation, Thumbs],
      thumbs: {
        swiper: thumbs,
      },
      navigation: {
        nextEl: nextSlideElement,
        prevEl: prevSlideElement
      },
    })

  })

}

initPostGallery()

/**
 *
 *
 var swiper = new Swiper(".mySwiper", {
      spaceBetween: 10,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
    });
 var swiper2 = new Swiper(".mySwiper2", {
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: swiper,
      },
    });

 *
 */
